export default {
  // Login
  login: 'Inicio de sesión',
  user: 'Usuario',
  password: 'Contraseña',
  forgotPassword: '¿Olvidó su contraseña?',
  signin: 'Ingresar',
  welcomeEcargo: 'Bienvenido a e-Cargo',
  // Forgot password
  recoveryPassword: 'Restablecer Contraseña',
  recovery: 'Restablecer',
  email: 'Correo electrónico',
  passwordRecovered: 'Contraseña reestablecida',
  weShipPassword: 'Le hemos enviado a su correo electrónico, una nueva contraseña temporal.',
  loginNow: '¡Iniciar sesión ahora!',
  // Favorites
  favorites: 'Favoritos',
  fastAccess: 'Acceso rápido a las funciones más consultadas del sistema.',
  // Menu
  menu: 'Menú',
  search: 'Buscar',
  // Notificaitons
  notifications: 'Notificaciones',
  lastAccess: 'Últimos Acceso',
  // Settings
  settings: 'Configuraciones',
  profile: 'Perfil',
  logout: 'Salir',
  fullName: 'Nombre Completo',
  record: 'Guardar',
  cPassword: 'Confirmar la nueva contraseña',
  country: 'País',
  changePicture: 'Cambiar foto',
  cancel: 'Cancelar'
}
